module.exports = {"id":"239475","name":"Jonathan González","rating":"71","photo":"./data/images/photos/3/239475.png","club":{"name":"Monterrey","logo":"./data/images/clubs/Monterrey.png"},"positions":["MC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JonathanGonzalez0.json
// module id = 2101
// module chunks = 0